import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import { getManagementAppPanelAsync } from './ManagementAppStore/managementDashboardSlice';
import ManagementPanel from './ManagementPanel';

function ManagementAppDash() {
  const dispatch = useDispatch();
  const [sortByPanel, setSortByPanel] = useState('week');

  const { mgmentPanel } = useSelector(({ dashboardManagementReducer }) => {
    return {
      mgmentPanel: dashboardManagementReducer.mgmentPanel,
    };
  });

  useEffect(() => {
    dispatch(getManagementAppPanelAsync({ sortby: 'week' }));
  }, []);

  const handleSortInfo = (e) => {
    setSortByPanel(e.target.value);
    dispatch(getManagementAppPanelAsync({ sortby: e.target.value }));
  };

  return (
    <Box pl={2}>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        School Panel
      </Box>
      <Box mb={2}>
        <BuzzSelect
          labelKey="label"
          valueKey="value"
          width={200}
          size={'small'}
          value={sortByPanel}
          onChange={handleSortInfo}
          options={[
            { label: 'Last Week', value: 'week' },
            { label: 'Last Month', value: 'month' },
            { label: 'Last Year', value: 'year' },
          ]}
        />
      </Box>
      <Box mb={8}>
        <ManagementPanel
          schoolRegistered={mgmentPanel ? mgmentPanel.schoolRegistered : 0}
          schoolOnboard={mgmentPanel ? mgmentPanel.onboardedSchool : 0}
          admisssions={mgmentPanel ? mgmentPanel.admissions : 0}
          enquiries={mgmentPanel ? mgmentPanel.enquires : 0}
        />
      </Box>
    </Box>
  );
}

export default ManagementAppDash;
